import { render, staticRenderFns } from "./FourArticlesSection.vue?vue&type=template&id=683bc278&scoped=true&"
import script from "./FourArticlesSection.vue?vue&type=script&lang=js&"
export * from "./FourArticlesSection.vue?vue&type=script&lang=js&"
import style0 from "./FourArticlesSection.vue?vue&type=style&index=0&id=683bc278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683bc278",
  null
  
)

export default component.exports